import { call, put, select } from 'redux-saga/effects';

import { takeLatest } from '../../../utils/reduxSaga';
import { actions as sagaActions, GET_USER_CALL_LOG } from './types';
import { actions as reduxActions, getters } from '../reducers';
import { actions as loaderReducActions } from '../../../partials/loader/reducers';
import { getData } from '../../../utils/http';
import mapCallLog from './mapCallLog';
import getMitelRequestProps from '../../../utils/getMitelRequestProps';
import { isDefined } from '../../../utils/isDefined';

export function fetchUserLogs({ areMissedCalls, showMore }) {
  return {
    type: sagaActions[GET_USER_CALL_LOG],
    areMissedCalls,
    showMore
  };
}

export function* getUserCallLog({ areMissedCalls = false, showMore = false }) {
  yield put(loaderReducActions.startSpinLoader());
  const { mitelToken, baseUrl, clientDomain, mitelUserId } = yield call(
    getMitelRequestProps
  );

  let olderThan = null;

  if (showMore) {
    const lastLogId = yield select(getters.getLastCallLogId);
    olderThan = JSON.stringify(lastLogId);
  }

  const itemType = areMissedCalls
    ? ['MISSED_CALL']
    : ['MISSED_CALL', 'INCOMING_CALL', 'OUTGOING_CALL'];

  const itemTypeString = itemType.reduce(
    (str, item) => {
      return `${str}&itemType=${item}`;
    },
    ['']
  );

  let log = [];
  let count = 0;

  try {
    const { historyItems } = yield call(
      getData,
      `${baseUrl}/api/communicationlog/${clientDomain}/${mitelUserId}?t=${mitelToken}${itemTypeString}&limit=10${
        isDefined(olderThan) ? `&olderThan=${olderThan}` : ''
      }`
    );

    if (!showMore) {
      const hintCount = yield call(
        getData,
        `${baseUrl}/api/communicationlog/${clientDomain}/${mitelUserId}?t=${mitelToken}${itemTypeString}&count=true`
      );

      count = hintCount;
    }

    const mappedLog = yield call(mapCallLog, historyItems);

    log = mappedLog;
  } catch (e) {
    console.warn(e);
  } finally {
    showMore
      ? yield put(reduxActions.addUserLogs(log))
      : yield put(reduxActions.setUserCallLog(log, count));

    yield put(loaderReducActions.stopSpinLoader());
  }
}

function* watchGetUserCallLog() {
  yield takeLatest(sagaActions[GET_USER_CALL_LOG], getUserCallLog);
}

export default watchGetUserCallLog();
